import React from 'react';
import './HomeScreen.css';
import CustomCard from '../../components/CustomCard';
import Navbar from '../../components/Navbar';
import { useUserInfo } from '../../hooks/useUserInfo';

// SVG Icons
import ProfileIcon from '../../assets/profile.svg';
import SavingsIcon from '../../assets/savings.svg';
import EnergyIcon from '../../assets/energy.svg';
import RenewEnergyIcon from '../../assets/renew-energy.svg';
import EuroIcon from '../../assets/euro.svg';
import TipsIcon from '../../assets/tips.svg';
import NotificationIcon from '../../assets/notification.svg';

const HomeScreen = () => {
  const { getUserName, isLoggedIn } = useUserInfo();

  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  const userName = getUserName() || 'User';

  const mockData = {
    user: {
      name: userName,
      date: formattedDate,
    },
    energy: {
      usage: '38.2',
      unit: 'kWh',
      moneySpent: '65.3',
      currency: '€',
    },
    info: {
      bestTime: 'Low energy\n cost now',
      savings: 'You saved €12\n this week',
      smartTip: 'Unplugging your TV can save you €15 a year!',
    },
  };

  // Custom components for Energy Usage and Money Spent
  const EnergyUsageContent = () => (
    <div className="energy-usage-content">
      <h3 className="usage-title">Energy Usage Today</h3>
    </div>
  );

  const EnergyUsageValue = () => (
    <div className="usage-value-container">
      <span className="usage-value">{mockData.energy.usage}</span>
      <span className="usage-unit">{mockData.energy.unit}</span>
    </div>
  );

  const MoneySpentContent = () => (
    <div className="money-spent-content">
      <h3 className="money-title">Money Spent</h3>
    </div>
  );

  const MoneySpentValue = () => (
    <div className="money-value-container">
      <div>
        <span className="money-value">{mockData.energy.moneySpent}</span>
        <span className="money-currency">{mockData.energy.currency}</span>
      </div>
      <button className="view-details-button">View details</button>
    </div>
  );

  return (
    <>
      <div className="home-screen responsive-container">
        {/* Header Section */}
        <header className="home-header">
          <div className="header-content">
            <div className="header-left">
              <h1 className="greeting">Hi, {mockData.user.name}</h1>
              <p className="date">{mockData.user.date}</p>
            </div>
            <div className="header-right">
              <button className="icon-button notification-btn">
                <img src={NotificationIcon} alt="Notifications" className="header-icon" />
              </button>
              <button className="icon-button profile-btn">
                <img src={ProfileIcon} alt="Profile" className="header-icon" />
              </button>
            </div>
          </div>
        </header>
        <hr />

        {/* Main Content */}
        <main className="home-main">
          {/* Energy Usage Section */}
          <section className="energy-section">
            <CustomCard
              variant="transparent"
              topIcon={<img src={EnergyIcon} alt="Energy" className="energy-icon" />}
              topComponent={<EnergyUsageContent />}
              bottomComponent={<EnergyUsageValue />}
            />

            <CustomCard
              variant="transparent"
              topIcon={<img src={EuroIcon} alt="Money" className="money-icon" />}
              topComponent={<MoneySpentContent />}
              bottomComponent={<MoneySpentValue />}
            />
          </section>

          {/* Information Section */}
          <section className="information-section">
            <h2 className="section-title">INFORMATION</h2>
            <div className="info-cards">
              <CustomCard
                variant="secondary"
                topComponent={
                  <div className="info-card-content">
                    <div className="info-card-header">
                      <img src={RenewEnergyIcon} alt="Best Time" className="info-card-icon" />
                      <h4 className="info-card-title">Best Time</h4>
                    </div>
                    <p className="info-card-description">{mockData.info.bestTime}</p>
                  </div>
                }
              />

              <CustomCard
                variant="secondary"
                topComponent={
                  <div className="info-card-content">
                    <div className="info-card-header">
                      <img src={SavingsIcon} alt="Savings" className="info-card-icon" />
                      <h4 className="info-card-title">Savings</h4>
                    </div>
                    <p className="info-card-description">{mockData.info.savings}</p>
                  </div>
                }
              />

              <CustomCard
                variant="primary"
                topComponent={
                  <div className="info-card-content info-card-content--primary">
                    <div className="info-card-header">
                      <img src={TipsIcon} alt="Smart Tips" className="info-card-icon" />
                      <h4 className="info-card-title info-card-title--primary">Smart Tips</h4>
                    </div>
                    <p className="info-card-description info-card-description--primary">{mockData.info.smartTip}</p>
                  </div>
                }
              />
            </div>
          </section>
        </main>
      </div>

      <Navbar activeItem="home" />
    </>
  );
};

export default HomeScreen;
